import React from 'react';

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/962780785034?text=اريد%20ان%20استفسر%20عن%20"
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-col items-center gap-1 px-3 py-2 group/wa"
      aria-label="اتصل بنا عبر واتساب"
    >
      <div className="w-12 h-12 rounded-2xl bg-[#25D366] flex items-center justify-center text-white transition-transform duration-200 will-change-transform hover:scale-105">
        <i className="fab fa-whatsapp text-2xl"></i>
      </div>
      <span className="text-xs font-medium text-light/80 transition-colors duration-200">
        اتصل بنا
      </span>
    </a>
  );
}

export default WhatsAppButton;